import type { OptionSchema } from '@chartforge/shared-types';
import { commonSchemas } from './common';

/**
 * Timeline-specific settings: row height, milestone markers, tooltip
 * behavior and time-scale granularity. These are plain data entries — the
 * UI kit renders controls for them generically.
 */
export const timelineSchemas: OptionSchema[] = [
  {
    id: 'timeline.timeScale',
    type: 'enum',
    label: 'Time scale',
    tier: 'trial',
    defaultValue: 'auto',
    group: 'data',
    validation: { options: ['auto', 'numeric', 'time'] }
  },
  {
    id: 'timeline.timeGranularity',
    type: 'enum',
    label: 'Time granularity',
    tier: 'basic',
    defaultValue: 'auto',
    group: 'data',
    validation: { options: ['auto', 'year', 'month', 'week', 'day'] }
  },
  {
    id: 'timeline.rowHeight',
    type: 'number',
    label: 'Timeline row height',
    tier: 'trial',
    defaultValue: 48,
    group: 'layout',
    validation: { min: 24, max: 160 }
  },
  {
    id: 'timeline.markerShape',
    type: 'enum',
    label: 'Milestone marker shape',
    tier: 'trial',
    defaultValue: 'circle',
    group: 'appearance',
    validation: { options: ['circle', 'diamond', 'square'] }
  },
  {
    id: 'timeline.markerSize',
    type: 'number',
    label: 'Milestone marker size',
    tier: 'trial',
    defaultValue: 12,
    group: 'appearance',
    validation: { min: 4, max: 30 }
  },
  {
    id: 'timeline.connectPoints',
    type: 'boolean',
    label: 'Connect milestones',
    tier: 'basic',
    defaultValue: true,
    group: 'appearance'
  },
  {
    id: 'timeline.tooltip',
    type: 'boolean',
    label: 'Enable tooltip',
    tier: 'trial',
    defaultValue: true,
    group: 'labels'
  }
];

/** Everything the timeline chart plugin exposes: common + timeline options. */
export const timelineChartSchemas: OptionSchema[] = [...commonSchemas, ...timelineSchemas];
